export default __webpack_public_path__ + "static/media/icon_smartphone.f0a81747.svg";